import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('expenseDocument', 'expenseDocuments');

const customActions = {
  async LOAD_expenseDocuments({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('expenseDocuments')
      .query({ $filter: 'IsDeleted eq false', $expand: 'LineItems,DocumentLinks' });
    commit('SET_expenseDocuments', data);
  },
  async LOAD_expenseDocument({ commit, rootGetters }, id) {
    const i = odata.parseId(id);
    const data = await odata.o(rootGetters)
      .get(`expenseDocuments(${i})`)
      .query({ $expand: 'LineItems,DocumentLinks' });
    commit('SET_expenseDocument', data);
  },
  async SAVE_expenseDocument({ commit, rootGetters, state }, expenseDocument) {
    const result = await odata.o(rootGetters)
      .post('expenseDocuments', expenseDocument)
      .query();
    const items = state.expenseDocuments;
    items.push(result);
    commit('SET_expenseDocuments', items);
  },
  async UPDATE_expenseDocument({ commit, rootGetters }, data) {
    const i = odata.parseId(data.id);
    await await odata.o(rootGetters)
      .put(`expenseDocuments(${i})`, data)
      .query();
    commit('SET_expenseDocument', data);
  },
};

export default { ...actions, ...customActions };
